export default __webpack_public_path__ + "static/media/ppt.caa96bc8.svg";